module.exports = __webpack_public_path__ + "static/media/infiviz_logo.f4b5f639.svg";